import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { faCircleArrowLeft, faHomeAlt, faPaperPlane, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FinancialService } from '../_services/financial.service';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-generate-maintenance',
    templateUrl: './generate-maintenance.component.html',
    styleUrls: ['./generate-maintenance.component.css'],
    standalone: false
})
export class GenerateMaintenanceComponent implements OnInit {

  faCircleArrowLeft = faCircleArrowLeft;
  faHomeAlt = faHomeAlt;
  faPaperPlane = faPaperPlane;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  generateForm!: FormGroup;

  showAdvancedOptions = false;
  isGenerating = false;

  property: any;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private financialService: FinancialService) { }

  ngOnInit(): void {
    let propertystr = localStorage.getItem('property');
    this.property = JSON.parse(propertystr ? propertystr : '{}');

    const today = new Date().toISOString().slice(0, 10);

    this.generateForm = this.formBuilder.group({
      periodStart: [today, Validators.required],
      periodEnd: [today, Validators.required],
      executionType: ['maintenance', Validators.required],
      amount: [''],
      unitNumber: [''],
      description: ['']
    });
  }

  get f() { return this.generateForm.controls; }

  toggleAdvanced(): void {
    this.showAdvancedOptions = !this.showAdvancedOptions;
  }

  goBack(): void {
    this.router.navigate(['/manage-property-menu']);
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  generate(): void {
    if (this.generateForm.invalid) {
      return;
    }

    if (!this.property?.id) {
      this.toastr.error('Property could not be identified.', 'Error');
      return;
    }

    const formdata = this.generateForm.value;

    if (new Date(formdata.periodEnd) < new Date(formdata.periodStart)) {
      this.toastr.error('Period end must be after period start.', 'Error');
      return;
    }

    const payload: any = {
      propertyId: this.property.id,
      periodStart: `${formdata.periodStart} 09:00:01`,
      periodEnd: `${(this.showAdvancedOptions ? formdata.periodEnd : formdata.periodStart)} 09:05:01`,
      executionType: formdata.executionType
    };

    if (this.showAdvancedOptions) {
      if (formdata.amount) {
        payload.amount = Number(formdata.amount);
      }
      if (formdata.unitNumber) {
        payload.unit_number = Number(formdata.unitNumber);
      }
      if (formdata.description) {
        payload.description = formdata.description;
      }
    }

    this.isGenerating = true;

    this.financialService.generateMonthlyMaintenance(payload).subscribe({
      next: (resp) => {
        this.isGenerating = false;
        this.toastr.success(resp.message ?? 'Maintenance generated successfully.', 'Success');
        if (!environment.production) {
          console.log('Generate monthly maintenance: response: ', resp);
        }
      },
      error: (error) => {
        this.isGenerating = false;
        this.toastr.error('Failed to generate monthly maintenance.', 'Error');
        if (!environment.production) {
          console.log('Generate monthly maintenance: failure response: ', error);
        }
      }
    });
  }
}
